/**
 * Expose all endponts for 'indicators'.
 */
export const alertsApiMock = () => ({
  dashboard: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({
          data: {
            alertsByGeoLocation: [
              {
                totalCount: 65,
                counters: {
                  NOT_HANDLED: 10,
                  IN_PROCESS: 20,
                  CLOSED: 35
                },
                group: "SURESTE"
              },
              {
                totalCount: 40,
                counters: {
                  NOT_HANDLED: 10,
                  IN_PROCESS: 5,
                  CLOSED: 15
                },
                group: "NOROESTE"
              }
            ],

            alertsByLogicalLocation: [
              {
                totalCount: 33,
                counters: {
                  NOT_HANDLED: 11,
                  IN_PROCESS: 9,
                  CLOSED: 13
                },
                group: "OLIVE_GARDEN"
              },
              {
                totalCount: 25,
                counters: {
                  NOT_HANDLED: 10,
                  IN_PROCESS: 13,
                  CLOSED: 2
                },
                group: "WINGS"
              }
            ],

            details: [
              {
                totalCount: 1,
                counters: {
                  NOT_HANDLED: 0,
                  IN_PROCESS: 1,
                  CLOSED: 0
                },
                geoLocation: "SURESTE",
                logicalLocation: "OLIVE_GARDEN",
                name: "WOW"
              },
              {
                totalCount: 1,
                counters: {
                  NOT_HANDLED: 1,
                  IN_PROCESS: 0,
                  CLOSED: 0
                },
                geoLocation: "SURESTE",
                logicalLocation: "OLIVE_GARDEN",
                name: "RESCUE"
              },
              {
                totalCount: 1,
                counters: {
                  NOT_HANDLED: 1,
                  IN_PROCESS: 0,
                  CLOSED: 0
                },
                geoLocation: "NOROESTE",
                logicalLocation: "WINGS",
                name: "RESCUE"
              },
              {
                totalCount: 1,
                counters: {
                  NOT_HANDLED: 0,
                  IN_PROCESS: 0,
                  CLOSED: 1
                },
                geoLocation: "NOROESTE",
                logicalLocation: "WINGS",
                name: "WOW"
              }
            ]
          },

          ok: true
        });
      }, 1000);
    }),
  alerts: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({
          data: [
            {
              id: 9301,
              geoLocationId: 9301,
              geoLocationName: "RESCUE",
              description: null,
              createdAt: "2019-05-05T09:29:10.596Z",
              updatedAt: null,
              updatedBy: null,
              alertStatus: "NOT_HANDLED",
              alertType: null,
              administrable: false,
              surveyResponseId: 9151,
              surveyResponseComment: null,
              surveyRawResponse: null
            },
            {
              id: 9302,
              geoLocationId: 9302,
              geoLocationName: "WOW",
              description: null,
              createdAt: "2019-05-05T09:29:10.596Z",
              updatedAt: null,
              updatedBy: null,
              alertStatus: "NOT_HANDLED",
              alertType: null,
              administrable: false,
              surveyResponseId: 9151,
              surveyResponseComment: null,
              surveyRawResponse: null
            },
            {
              id: 9451,
              geoLocationId: 9451,
              geoLocationName: "RESCUE",
              description: null,
              createdAt: "2019-05-05T09:37:37.418Z",
              updatedAt: null,
              updatedBy: null,
              alertStatus: "NOT_HANDLED",
              alertType: null,
              administrable: false,
              surveyResponseId: 9351,
              surveyResponseComment: null,
              surveyRawResponse: null
            },
            {
              id: 9452,
              geoLocationId: 9452,
              geoLocationName: "WOW",
              description: null,
              createdAt: "2019-05-05T09:37:37.418Z",
              updatedAt: null,
              updatedBy: null,
              alertStatus: "NOT_HANDLED",
              alertType: null,
              administrable: false,
              surveyResponseId: 9351,
              surveyResponseComment: null,
              surveyRawResponse: null
            },
            {
              id: 9601,
              geoLocationId: 9601,
              geoLocationName: "RESCUE",
              description: null,
              createdAt: "2019-05-05T10:16:36.202Z",
              updatedAt: null,
              updatedBy: null,
              alertStatus: "NOT_HANDLED",
              alertType: null,
              administrable: false,
              surveyResponseId: 9501,
              surveyResponseComment: null,
              surveyRawResponse: null
            },
            {
              id: 9602,
              geoLocationId: 9602,
              geoLocationName: "WOW",
              description: null,
              createdAt: "2019-05-05T10:16:36.203Z",
              updatedAt: null,
              updatedBy: null,
              alertStatus: "NOT_HANDLED",
              alertType: null,
              administrable: false,
              surveyResponseId: 9501,
              surveyResponseComment: null,
              surveyRawResponse: null
            }
          ],
          ok: true
        });
      }, 1000);
    }),
  alertById: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({
          data: {
            id: 9602,
            name: "WOW",
            description: null,
            createdAt: "2019-05-05T10:16:36.203Z",
            customerName: "test",
            customerLastName: "testLastname",
            updatedAt: null,
            updatedBy: null,
            alertStatus: "IN_PROCESS",
            alertType: null,
            alertComments: [],
            administrable: false,
            surveyResponseId: null,
            surveyResponseComment: null,
            surveyRawResponse:
              '{"result":{"ENVIRONMENT_GENERAL":5,\n"FOOD_GENERAL":4,\n"SERVICE_GENERAL":3,\n"SATISFACTION":2,\n"SAMPLER_OFFER":1,\n"WILLINGNESS_TO_RETURN":2,\n"WILLINGNESS_TO_RECOMMEND":1,\n"RESCUE_TEXT":"El mesero horrible, la comida normal",\n"WOW_TEXT":"Wow! genial. El autobus transporte excelente",\n"ENVIRONMENT_PROBLEM":["ENVIRONMENT_FURNITURE","ENVIRONMENT_ILLUMINATION"]},\n"contact":{"email":"ppastorino@gmail.com","name":"Pablo","lastName":"Pastorino"}}'
          },
          ok: true
        });
      }, 1000);
    }),
  comments: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({
          data: [
            {
              id: 9651,
              alertId: 9602,
              createdAt: "2019-05-06T21:16:54.441Z",
              createdBy: "admin",
              text: "comentario sobre el alerta"
            }
          ],
          ok: true
        });
      }, 1000);
    }),
  changeStatus: () =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({
          data: [{}],
          ok: true
        });
      }, 1000);
    })
});

export const alertsApi = api => ({
  getResolutions: id => api.get(`alerts/${id}/resolutions`),
  dashboard: filters => api.get("alerts/dashboard", filters),
  alerts: filters => api.get("alerts", filters),
  alertById: id => api.get(`alerts/${id}`),
  comments: id => api.get(`alerts/${id}/comments`),
  changeStatus: ({ id, data }) => {
    return api.put(`alerts/${id}`, data);
  }
});



// WEBPACK FOOTER //
// ./src/services/api/alertsApi.js